export default {
    AppSync: {
        authenticationType: 'AMAZON_COGNITO_USER_POOLS',
        graphqlEndpoint: process.env.REACT_APP_GQL_ENDPOINT,
        region: process.env.REACT_APP_AWS_REGION,
    },
    AWSPinpoint: {
        appId: process.env.REACT_APP_PINPOINT_ID,
        region: process.env.REACT_APP_AWS_REGION,
        mandatorySignIn: true,
    },
    cognito: {
        APP_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID,
        IDENTITY_POOL_ID: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
        REGION: process.env.REACT_APP_AWS_REGION,
        USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
    },
    google: {
        api: process.env.REACT_APP_GOOGLE_API,
    },
    MapBoxAPI: process.env.REACT_APP_MAPBOX,
    OpenWeather: {
        url: 'https://api.openweathermap.org/data/2.5',
        apiKey: process.env.REACT_APP_OPEN_WEATHER_API,
    },
}
